import * as React from "react";
import type { SVGProps } from "react";
const SvgBasementIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M3 2v12.96c0 .264.225.48.5.48h1v10.08c0 .264.225.48.5.48h18c.275 0 .5-.216.5-.48V15.44h1c.275 0 .5-.216.5-.48V2h-1v12.48h-3V6.8a.49.49 0 0 0-.5-.48h-5.547a.486.486 0 0 0-.453.48v7.68H4V2zm4.406 0A.485.485 0 0 0 7 2.48v3.84c0 .264.225.48.5.48h4c.275 0 .5-.216.5-.48V2.48a.49.49 0 0 0-.5-.48H7.406M8 2.96h3v2.88H8zm7.5 4.32H20v7.2h-4.5zm-10 8.16h17v9.6h-6.969v-1.47h-2v-1.92h-2v-1.92h-2v-1.92h-2v-1.92H5.5zm0 1.47h.969v1.92h2v1.92h2v1.92h2v1.92h2v.45H5.5z"
    />
  </svg>
);
export default SvgBasementIcon;
